import React from 'react';
import FocusLayout from '../../components/FocusLayout';
import Redeem from '../../components/Redeem';
import { getSalesChannelBySlug, setSalesChannel } from '../../actions/config';

async function action({ store, client }, { slug, voucherCode }) {
  const { group, id } = await store.dispatch(getSalesChannelBySlug(slug));

  if (!group || group !== 'Portal' || !id) {
    return undefined;
  }

  const {
    presentations: {
      pageDescription,
      pageTitle,
      portalBannerMobile,
      portalBannerDesktop,
      ...rest
    },
    logoUrl,
    bannerUrl,
    colorScheme,
  } = await store.dispatch(setSalesChannel(id));

  return {
    chunks: ['portal'],
    title: pageTitle,
    description: pageDescription,
    salesChannelId: id,
    component: (
      <FocusLayout
        focusContentBox={false}
        gradient
        footer
        footerBar
        logo={logoUrl}
        backgroundImage={bannerUrl}
        color={colorScheme}
      >
        <Redeem
          presentations={rest}
          redirectToShop
          client={client}
          voucherCode={voucherCode}
        />
      </FocusLayout>
    ),
  };
}

export default action;
